import React from 'react';
import { connect } from 'react-redux';
import {Typography} from '@hpstellar/core';

import { Helpers } from '../../core/src/helpers';
import { getIcon, isSVG, isImageSrc } from '../../category-landing-page/components/shared';

import './shopping-links.less';

const ShoppingLinks = ({ custSeg, shoppingLinks }) => {
    return (
        <section className="shoppingLinks">
            <div className="large-12">
                <ul>
                    {/* TODO: whats the customer segment stuff? does it apply now that this footer is on the whole page? */}
                    {shoppingLinks &&
                        shoppingLinks.map(({ href, name, key, customerSegements, icon }, i) => {
                            // if (!customerSegements || customerSegements.indexOf(custSeg) > -1) {

                            let renderIcon = null;
                            if (icon && isImageSrc(icon)) {
                                renderIcon = (
                                    <span className="icon img-container">
                                        <img src={icon} />
                                    </span>
                                );
                            } else if (icon && isSVG(icon)) {
                                renderIcon = (
                                    <span className="svg-icon" dangerouslySetInnerHTML={Helpers.createMarkup(icon)} />
                                );
                            } else {
                                renderIcon = <span className="icon">{getIcon(icon, null, 'm')}</span>;
                            }

                            return (
                                <li key={`ShoppingLink-${i}`}>
                                    <a href={href} className="link">
                                        {renderIcon}
                                        <Typography className="linkText" variant="bodyS">
                                            {name || key}
                                        </Typography>
                                    </a>
                                </li>
                            );
                            // } else {
                            //     return null;
                            // }
                        })}
                </ul>
            </div>
        </section>
    );
};

const mapStateToProps = (state, ownProps) => {
    const { userData, headerFooter = {} } = state;
    const { profileData = {} } = userData;
    const { shoppingLinks } = headerFooter.disclaimer || {};
    const { components = {}, gql } = state.slugInfo;
    const { footerLinks } = components;

    return {
        custSeg: profileData.personData.custSeg,
        shoppingLinks: gql ? footerLinks : shoppingLinks,
    };
};

export default connect(mapStateToProps, null)(ShoppingLinks);
